import axios from '../axiosInstance';
import type { FetchCourseCategoriesResponse } from './types';

/**
 * Fetch all course categories with hierarchical structure
 * GET /api/learning-center/course-categories
 */
export const fetchCourseCategories = async (): Promise<FetchCourseCategoriesResponse> => {
  const response = await axios.get<FetchCourseCategoriesResponse>(
    '/api/learning-center/course-categories'
  );
  return response.data;
};
